module.exports = __webpack_public_path__ + "static/img/catch-type-icon.a933434b.png";